import * as Types from './planningActionTypes.js'

const initialState = {
    data: [],
    date: new Date(),
    createEditDrawerOpen: false
};

export default function planning(state = initialState, action) {
    switch (action.type) {
        case Types.SET_PLANNINGDATA:
            if (state.data !== action.data) {
                return Object.assign({}, state, { data: action.data });
            }
            return state;
        case Types.SET_PLANNINGDATE:
            if (state.date !== action.date) {
                return Object.assign({}, state, { date: action.date });
            }
            return state;
        case Types.SET_CREATEEDITDRAWEROPEN:
            if (state.createEditDrawerOpen !== action.createEditDrawerOpen) {
                return Object.assign({}, state, { createEditDrawerOpen: action.createEditDrawerOpen });
            }
            return state;
        default:
            return state;
    }
}